import React from 'react';

const ChipAlert = (props) => (
  <div className='relative mx-1 h-7 w-max '>
    <div className={`flex btn-${props.alertColor}`}>
      {props.children}{' '}
      <div
        className='ml-1 rounded-full cursor-pointer bg-whith-opacity50 hover:bg-white'
        onClick={() => props.onAcknowledge(props.alert, props.clearAlert)}
      >
        <svg
          width='21'
          height='21'
          viewBox='0 0 21 21'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className={`ack-${props.alertColor}`}
        >
          <path d='M6.5 11L9 14L15.5 6' strokeWidth='1.5' />
        </svg>
      </div>
    </div>
  </div>
);

export default ChipAlert;
